import React from 'react';

export const PageHeader = ({ sectionNumber, dark = false }) => (
    <div className="page-header" style={{ position: 'absolute', top: '15mm', left: '20mm', right: '20mm', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${dark ? 'rgba(255,255,255,0.1)' : '#f1f5f9'}`, paddingBottom: '10px' }}>
        <div style={{ color: dark ? '#069668' : '#64748b', fontSize: '10px', fontWeight: '800', letterSpacing: '2px' }}>
            SECTION {sectionNumber} <span style={{ mx: '10px', opacity: 0.3 }}>|</span> YATHARTHA ANALYSIS
        </div>
        <img src="/Yathartha-Logo.png" alt="Logo" style={{ height: '18px', filter: dark ? 'brightness(0) invert(1)' : 'none' }} />
    </div>
);

export const PageFooter = ({ pageNumber, clientName, dark = false }) => (
    <div className="page-footer" style={{ position: 'absolute', bottom: '15mm', left: '20mm', right: '20mm', borderTop: `1px solid ${dark ? 'rgba(255,255,255,0.1)' : '#f1f5f9'}`, paddingTop: '15px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '9px', color: dark ? '#94a3b8' : '#64748b', fontWeight: '600' }}>
                CONFIDENTIAL: {(clientName || "VALUED CLIENT").toUpperCase()}
            </div>
            <div style={{ background: '#069668', color: '#fff', width: '28px', height: '28px', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '900' }}>
                {pageNumber}
            </div>
        </div>
        <div style={{ fontSize: '7px', color: dark ? '#475569' : '#cbd5e1', marginTop: '10px', textAlign: 'center' }}>
            © {new Date().getFullYear()} Yathartha Financial | Precision Wealth Diagnosis Engine | Icons by <a href="https://www.flaticon.com/" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>Flaticon</a>
        </div>
    </div>
);
